export const enum EnumAuditValueType { SHORT = 'SHORT', STRING = 'STRING' }

export interface IAuditColValue {
    auditValue: number | string | null;
    value: number | string | null;
}

export interface IAuditColResource {
    block: string;
    type: string;
    question: string;
    itemUuid: string;
    valueType: EnumAuditValueType;
    pair: IAuditColValue;
}

export interface IAuditCreatedByResource {
    id: number;
    uuid: string | null;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    roles: string[];
    modules: string[];
}

export interface IAuditRevisionResource {
    revision: string | null;
    createdBy: IAuditCreatedByResource;
    numMetricSum: number;
    numMetricTotal: number;
    cols: IAuditColResource[];
}

export interface IAuditChecklistItem {
    id: number;
    uuid: string;
    name: string;
}

export interface IPostAuditBody {
    checklistUuid: string;
    data: Record<string, string | null>;
}

export function mapAuditRevisions(raw: unknown): IAuditRevisionResource[] {
    if (!Array.isArray(raw)) return [];
    return raw.map((item: Record<string, unknown>) => ({
        revision: (typeof item.revision === 'string' ? item.revision : null),
        createdBy: (item.createdBy ?? null) as IAuditCreatedByResource,
        numMetricSum: Number(item.numMetricSum) || 0,
        numMetricTotal: Number(item.numMetricTotal) || 0,
        cols: Object.entries(item)
            .filter(([key]) => key.startsWith('col') && !isNaN(parseInt(key.slice(3))))
            .sort(([a], [b]) => parseInt(a.slice(3)) - parseInt(b.slice(3)))
            .map(([, val]) => val as IAuditColResource),
    }));
}
